<template>
<div class="page-bar">
  <ul>{{forIndex}}--{{forLink}}--{{forList}}
    <li class="pre-page" v-if="forIndex>1"><router-link :to="{path:forLink,query:{id:forList[forIndex-1].id}}">{{forList[forIndex-1].id}}</router-link></li>
    <li class="next-page" v-if="forIndex<(forList.length-1)"><router-link :to="{path:forLink,query:{id:forList[forIndex+1].id}}">{{forList[forIndex+1].id}}</router-link></li>
  </ul>
</div>
</template>
<script>
export default {
  name: 'PreviousNextNav',
  props: {
    forList: {
      type: Array,
      default: function(){return []}
    },
    forIndex: {
      type: Number,
      default: 0
    },
    forLink: {
      type: String,
      default: "/"
    },
  },
  data() {
    return {
      maxIndex: 10,
      totalPage: 2,
      totalRecord: 200,
      currentPage: 1,
      pageSize: 10,
      pageList: []
    }
  },
  created: function() {

  },
  methods: {
  }
}
</script>
<style scoped>
.item-action li:before {
  content: "样式：";
}

.page-bar {
  width:100%;
  height:80px;
  padding-top: 20px;
  border-top:1px solid #ddd;
}

.page-bar ul{
  display: flex;
  justify-content:space-between;
  height:60px;
  width: 100%;
}

.page-bar li {
  list-style: none;
  float:left;
}

.page-bar li:first-child>a {
  margin-left: 0px
}

.page-bar a {
  height: auto;
  display:block;
  border: 0px solid #ddd;
  text-decoration: none;
  padding: 6px 12px;
  margin-left: 4px;
  line-height: 1.42857143;
  color: var(--color7);
  cursor: pointer;
  margin-right: 4px;
}

.page-bar a:hover {
  color: var(--color6);
}

.page-bar .current-page {
  background-color: var(--color6);
  color: #fff;
}

.page-bar a.banclick {
  cursor: not-allowed;
}

.page-bar .active a {
  color: #fff;
  cursor: default;
  background-color: #E96463;
  border-color: #E96463;
}

.page-bar i {
  font-style: normal;
  color: #d44950;
  margin: 0px 4px;
  font-size: 12px;
}

.page-bar .pre-page a:before{
  content: "<上一篇    ";
  color:#000;
}

.page-bar .next-page a:after{
  content: "    上一篇>";
  color:#000;
}
</style>



// WEBPACK FOOTER //
// src/components/utils/PreviousNextNav.vue